/** Same lifetime as the server session JWT (JWT_COOKIE_MAX_AGE_MS). */
export const PARTNER_AUTH_COOKIE_MAX_AGE = 7 * 86400

function apiOrigin() {
  if (import.meta.env.DEV) {
    return typeof window === 'undefined' ? '' : window.location.origin
  }
  try {
    return new URL(import.meta.env.VITE_BASE_URL).origin
  } catch {
    return typeof window === 'undefined' ? '' : window.location.origin
  }
}

/**
 * Partner pages call the API on another host and keep the session in
 * sessionStorage (x-auth). A full navigation or an admin bundle request
 * cannot send that header. adminAssetGuard only sees the `user` cookie,
 * so the same token has to live on this host too.
 */
export function isPartnerBrowserPage() {
  if (typeof window === 'undefined') return false
  const page = window.location.origin
  return page !== '' && page !== apiOrigin()
}

function openedAsPopup() {
  try {
    return Boolean(window.opener && !window.opener.closed)
  } catch {
    return true
  }
}

export function partnerAuthCookieAssignment(token, { secure = false } = {}) {
  const secureAttr = secure ? '; Secure' : ''
  return `user=${encodeURIComponent(token)}; Path=/; Max-Age=${PARTNER_AUTH_COOKIE_MAX_AGE}; SameSite=Lax${secureAttr}`
}

export function clearPartnerAuthCookieAssignment() {
  return 'user=; Path=/; Max-Age=0; SameSite=Lax'
}

export function syncPartnerAuthCookie(token) {
  if (!isPartnerBrowserPage() || openedAsPopup()) return
  if (typeof token !== 'string' || !token) return
  document.cookie = partnerAuthCookieAssignment(token, {
    secure: window.location.protocol === 'https:',
  })
}

export function clearPartnerAuthCookie() {
  if (!isPartnerBrowserPage() || openedAsPopup()) return
  document.cookie = clearPartnerAuthCookieAssignment()
}
